import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import LogoutIcon from "@mui/icons-material/Logout";
import { AppBar, IconButton, Toolbar, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";

import { signOut } from "@/api/auth";
import { useThemeStore } from "@/stores/useThemeStore";

import styles from "./AppShell.module.css";

export const AppShell = () => {
    // State
    const mode = useThemeStore((state) => state.mode);
    const toggleMode = useThemeStore((state) => state.toggleMode);

    return (
        <div className={styles.root}>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div" className={styles.title}>
                        Nova
                    </Typography>
                    <IconButton color="inherit" aria-label="Toggle theme mode" onClick={toggleMode}>
                        {mode === "light" ? <DarkModeIcon /> : <LightModeIcon />}
                    </IconButton>
                    <IconButton color="inherit" aria-label="Sign out" onClick={signOut}>
                        <LogoutIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Outlet />
        </div>
    );
};
